import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'acontoType',
    standalone: false
})
export class AcontoTypePipe implements PipeTransform {
    transform(acontoTypeNumber: number): string {
        switch (acontoTypeNumber) {
            case 0: return 'Mdr';
            case 1: return 'Kvt';
            case 2: return '1/2 år';
            case 3: return 'År';
            default: return '';
        }
    }
}
